import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, GraduationCap } from "lucide-react";
import { track } from "@/lib/analytics";

const NAV_EVENT = { "/compare": "compare_colleges_click", "/expert-counseling": "expert_counselling_click" };

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/colleges", label: "Colleges" },
  { to: "/ai-counseling", label: "AI Counseling" },
  { to: "/expert-counseling", label: "Expert Counseling" },
  { to: "/compare", label: "Compare" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 w-full backdrop-blur-xl bg-white/80 border-b border-slate-200">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex h-16 items-center justify-between">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#0B2A6B]">
            <GraduationCap className="h-5 w-5 text-white" />
          </span>
          <span className="font-display text-lg font-extrabold tracking-tight text-[#0B2A6B]">
            College<span className="text-[#D4A24C]">Unlock</span>
          </span>
        </Link>

        <div className="hidden lg:flex items-center gap-1">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => { if (NAV_EVENT[l.to]) track(NAV_EVENT[l.to], { location: "navbar" }); }}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                  isActive ? "text-[#0B2A6B] bg-slate-100" : "text-slate-600 hover:text-[#0B2A6B]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <NavLink
            to="/campus-truth"
            data-testid="nav-link-campus-truth"
            className={({ isActive }) =>
              `px-3 py-2 text-sm font-semibold rounded-md transition-colors ${
                isActive ? "bg-[#D4A24C]/15" : "hover:bg-[#D4A24C]/10"
              }`
            }
            style={{ color: "#D4A24C" }}
          >
            Campus Truth
          </NavLink>
          <Link
            to="/ai-counseling"
            data-testid="navbar-cta-btn"
            className="ml-2 inline-flex items-center rounded-lg bg-[#0B2A6B] px-4 py-2 text-sm font-semibold text-white hover:bg-[#081E4D] transition-colors"
          >
            Start Free AI Counseling
          </Link>
        </div>

        <button
          data-testid="navbar-hamburger"
          className="lg:hidden p-2 text-[#0B2A6B]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white px-4 py-3 space-y-1" data-testid="navbar-mobile-menu">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => { if (NAV_EVENT[l.to]) track(NAV_EVENT[l.to], { location: "navbar_mobile" }); setOpen(false); }}
              className={({ isActive }) =>
                `block px-3 py-2 text-sm font-medium rounded-md ${
                  isActive ? "text-[#0B2A6B] bg-slate-100" : "text-slate-700"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <NavLink
            to="/campus-truth"
            onClick={() => setOpen(false)}
            data-testid="nav-link-campus-truth-mobile"
            className="block px-3 py-2 text-sm font-semibold rounded-md"
            style={{ color: "#D4A24C" }}
          >
            Campus Truth
          </NavLink>
          <Link
            to="/ai-counseling"
            onClick={() => setOpen(false)}
            className="block text-center rounded-lg bg-[#0B2A6B] px-4 py-2.5 text-sm font-semibold text-white"
          >
            Start Free AI Counseling
          </Link>
        </div>
      )}
    </header>
  );
}
